import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function PrivacyPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-6 pb-12">
        <div className="w-full px-4 md:px-6 lg:px-8 max-w-3xl mx-auto">
          <nav className="text-sm text-stone-500 mb-6">
            <a href="/" className="hover:text-emerald-700 transition-colors">{t('breadcrumb_home')}</a>
            <span className="mx-2">/</span>
            <span className="text-stone-700">Privacy</span>
          </nav>

          <h1 className="text-3xl md:text-4xl font-bold text-stone-800 mb-6">Privacy Policy</h1>

          <div className="space-y-6">
            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">Information We Collect</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                CSSBuyBR is a static informational website. We do not collect personal data through forms, accounts, or user registrations. We may collect anonymous usage data through standard analytics tools to understand how visitors use our website. This data includes page views, time spent on site, and general geographic information, but does not identify individual users.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">Cookies</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                We use cookies to improve your browsing experience. Cookies are small files stored on your device that help us remember your language preferences and other basic settings. You can choose to disable cookies through your browser settings, though this may affect some functionality of the website.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">Third-Party Links</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                Our website contains links to external websites. We are not responsible for the privacy practices or content of these external sites. We encourage you to review the privacy policies of any third-party websites you visit.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">Data Security</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                We take reasonable precautions to protect any information collected through our website. However, as this is primarily an informational site with no user accounts or payment processing, the amount of data collected is minimal.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">Changes to This Policy</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                We may update this privacy policy from time to time. Any changes will be posted on this page with an updated effective date. We encourage you to review this policy periodically.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">Contact Us</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                If you have any questions about this privacy policy, please contact us through our <a href="/contact/" className="text-emerald-700 hover:underline">contact page</a>.
              </p>
            </section>
          </div>

          <p className="mt-8 text-xs text-stone-400">Last updated: August 27, 2026</p>
        </div>
      </main>
      <Footer />
    </div>
  );
}